"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useGuidedSellingStatus = require("../../hooks/app/useGuidedSellingStatus");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _useAppSelector = require("../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const HeaderTop = _ref => {
  let {
    actionComponent,
    isCloseButtonHidden,
    headerText,
    headerSubText,
    showDivider,
    id = ''
  } = _ref;
  const {
    closeGuidedSellingModal
  } = (0, _useGuidedSellingStatus.useGuidedSellingStatus)();
  const {
    showModalView
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const adustCloseBtn = (0, _useLocalTheme.default)('header.adustCloseBtn', false);
  const spacingLevel = (0, _useLocalTheme.default)('recommendation.spacingLevel', 1);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: spacingLevel
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, headerText && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: headerText,
    size: 3,
    weight: 1,
    justify: "center"
  }), headerSubText && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: headerSubText,
    size: 1,
    weight: 2,
    justify: "center"
  })), actionComponent && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: 'left',
    verticalAlign: 'stretch'
  }, actionComponent)), showModalView && !isCloseButtonHidden && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: 'right',
    verticalAlign: 'stretch'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.InteractiveIcon, {
    dataAttributes: {
      'data-test-id': 'overlay-button-close'
    },
    srText: "Close",
    name: "close",
    size: adustCloseBtn ? 5 : 4,
    appearance: "primary",
    onClick: closeGuidedSellingModal
  }))))), showDivider && !adustCloseBtn && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
    noMargin: true
  }));
};
var _default = HeaderTop;
exports.default = _default;